import { Formik } from 'formik';
import { validationSchemaTicket, initValuesTicket } from './createTicketValidation';
import Form from "./TicketForm";
import { useAxios } from "../../../../context/AxiosHookContext";
import getDayjs from '../../../../context/DateInstance';

const FormCreateTicket = ({ onClose, valuesToEdit, getValues }) => {


    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initValuesTicket
    }

    const axios = useAxios();

    const handleSubmit = async (ticket) => {

        try {

            let result;

            if (ticket._id) {

                if (ticket.status === "Finished") {
                    return
                }

                result = await axios.put(`/tickets/${ticket._id}`, ticket)

            } else {

                result = await axios.post("/tickets", ticket);

            }


            if (ticket?.files?.length > 0) {

                const ticketId = result?.data?.data._id || null;

                if (ticketId) {

                    for (const key in Object.keys(ticket?.files)) {

                        const file = ticket?.files[key];
                        const form = new FormData();
                        form.append('file', file);
                        await axios.post(`/tickets/uploadDocument/${ticketId}`, form)

                    }
                }

            }

        } catch (error) {
            console.log(error)
        } finally {
            getValues();
        }

    }

    return (
        <Formik
            validationSchema={validationSchemaTicket}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
            validateOnChange
        >
            <Form onClose={() => { getValues(); onClose() }} />
        </Formik>
    )
}

export default FormCreateTicket